/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Itemsperpage2Inputs */

const en_common_itemsperpage2 = /** @type {(inputs: Common_Itemsperpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items per page`)
};

/**
* | output |
* | --- |
* | "Items per page" |
*
* @param {Common_Itemsperpage2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_itemsperpage2 = /** @type {((inputs?: Common_Itemsperpage2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Itemsperpage2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_itemsperpage2(inputs)
});
export { common_itemsperpage2 as "common_itemsPerPage" }